<div class="fullloader-bg">
	<div class="flipping">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>